var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { FirebaseAuthContext } from 'libs.firebase_react';
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
import { ApiClientService, useApiClient } from 'libs.react';
/**
 *  Extracts the filename from the content disposition header
 *  Content-Disposition: attachment; filename="example.json" => example.json
 */
function extractFilenameFromContentDisposition(contentDisposition) {
    const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = regex.exec(contentDisposition);
    if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
    }
    return null;
}
function downloadFile(response) {
    const href = window.URL.createObjectURL(response.data);
    const anchorElement = document.createElement('a');
    anchorElement.href = href;
    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'strings.json';
    if (contentDisposition) {
        fileName = extractFilenameFromContentDisposition(contentDisposition) || fileName;
    }
    anchorElement.download = fileName;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
}
export function useLocalizationExport({ onSuccess } = {}) {
    const translate = useLocalizeMessage();
    // const { post } = useApiClient(ApiClientService.WEB);
    const { post } = useApiClient(ApiClientService.CLOUD);
    const { addNotification } = useToastNotification();
    const { firebaseToken } = useContext(FirebaseAuthContext);
    const { mutate: exportLocalization, isPending: isFetching, isSuccess, isError, } = useMutation({
        mutationKey: ['translation', 'export'],
        mutationFn: ({ assets, resources, scope, viewport, study }) => __awaiter(this, void 0, void 0, function* () {
            // TODO Use proper `new URL` code.
            if (!firebaseToken) {
                addNotification({
                    title: translate('Network error: please try again in a moment'),
                    type: 'error',
                });
                return;
            }
            addNotification({
                title: translate('Export package is getting prepared'),
                subtitle: translate('Download will start when available in a few minutes'),
                type: 'success',
                timeout: 3000,
            });
            return yield post(
            // '/api/translation/export',
            '/translation/export', {
                study,
                scope,
                viewport,
                resources,
                assets,
            }, {
                responseType: 'blob',
                // Pass firebase token, don't pass medable token
                withCredentials: false,
                headers: {
                    Authorization: `Bearer ${firebaseToken}`,
                },
            });
        }),
        onSuccess: (data) => {
            downloadFile(data);
            addNotification({
                title: translate('Package exported'),
                subtitle: translate('Your download should start automatically'),
                type: 'success',
                timeout: 3000,
            });
            if (onSuccess) {
                onSuccess();
            }
        },
        onError: (error) => {
            var _a;
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 408) {
                addNotification({
                    title: translate('Export failed'),
                    subtitle: translate('The export has timed out due to the size of the export. Please reduce the amount of assets and try again.'),
                    type: 'error',
                });
            }
        },
    });
    return { exportLocalization, isFetching, isSuccess, isError };
}
//# sourceMappingURL=localization_export.hook.js.map